"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTemplate = exports.insertStylingElements = exports.insertConditionals = void 0;

var _react = _interopRequireDefault(require("react"));

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/jsx-closing-tag-location */

/**
 * Render Template
 *
 * This utility sets up our template strings to be called in the views themselves.
 *
 * This utility replaces the string template on a given key with a closure including
 * that template which can be passed any additional conditional text for rendering
 * within the view itself.
 *
 * The template can be one of three types:
 *
 * * String: The simplest form of template, this can accept both styling and conditional
 * text, but has no default text to fall back upon if a conditional is not passed in.
 *
 * * Object: These are the same as strings in many ways, with the only major difference being
 * that they can fall back to default text. These are constructed like this:
 *
 * {
 *   template: 'A template string with a {{conditional}}',
 *   defaultStrings: {
 *     conditional: 'my fallback text'
 *   }
 * }
 *
 * * Arrays: Although it's not fully supported in our string templates system, some templates
 * that exist in our apps come in an array format. In these cases, the array itself is wrapped
 * in the closure and returned back when called.
 */
var insertConditionals = function insertConditionals() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$templateString = _ref.templateString,
      templateString = _ref$templateString === void 0 ? '' : _ref$templateString,
      _ref$defaultStrings = _ref.defaultStrings,
      defaultStrings = _ref$defaultStrings === void 0 ? {} : _ref$defaultStrings,
      _ref$conditionalParam = _ref.conditionalParameters,
      conditionalParameters = _ref$conditionalParam === void 0 ? {} : _ref$conditionalParam;

  if (typeof templateString !== 'string') {
    return '';
  }

  var splitTemplate = templateString.split(/{{|}}/g);
  var rawSplitTemplate = splitTemplate.reduce(function (accum, slice, index) {
    if (index % 2) {
      var conditional = conditionalParameters[slice] || defaultStrings[slice] || '';
      return accum + conditional;
    }

    return accum + slice;
  }, '');
  return rawSplitTemplate;
};

exports.insertConditionals = insertConditionals;

var insertStylingElements = function insertStylingElements(templateString) {
  if (typeof templateString !== 'string') {
    return '';
  }

  if (!templateString || !/((<\/)+|(\s\/>)+)/g.test(templateString)) {
    return templateString;
  }

  var sanitizedTemplateString = (0, _sanitizeHtml.default)(templateString, {
    allowedTags: ['b', 'i', 'em', 'strong', 'br']
  }); // eslint-disable-next-line react/no-danger

  return /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: sanitizedTemplateString
    }
  });
};

exports.insertStylingElements = insertStylingElements;

var renderTemplate = function renderTemplate(template) {
  return function () {
    var conditionalParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if ((0, _lodash.isArray)(template)) {
      return template;
    }

    var templateString = typeof template !== 'string' && Object.prototype.hasOwnProperty.call(template, 'template') ? template.template : template;
    var defaultStrings = typeof template !== 'string' && Object.prototype.hasOwnProperty.call(template, 'defaultStrings') ? template.defaultStrings : {};
    var paramaterizedTemplate = insertConditionals({
      templateString: templateString,
      defaultStrings: defaultStrings,
      conditionalParameters: conditionalParameters
    });
    var styledTemplate = insertStylingElements(paramaterizedTemplate);
    return styledTemplate;
  };
};

exports.renderTemplate = renderTemplate;